import { reactive, toRefs } from 'vue'

const state = reactive({
  activeTab: 'creators', // 'creators' | 'consumers'
  activeTimeframe: '30d', // '1d', '7d', '30d'
  topUsers: []
})

export default toRefs(state)
